export const NAV = {
  logo: "nav-logo",
  storeLink: "nav-store-link",
  studioLink: "nav-studio-link",
  libraryLink: "nav-library-link",
  loginBtn: "nav-login-btn",
  logoutBtn: "nav-logout-btn",
  userName: "nav-user-name",
};

export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  submitBtn: "auth-submit-btn",
  toggleModeBtn: "auth-toggle-mode-btn",
  googleBtn: "auth-google-btn",
};

export const STORE = {
  hero: "store-hero",
  categoryFilter: (cat) => `store-filter-${cat}`,
  productCard: (id) => `store-product-card-${id}`,
  emptyState: "store-empty-state",
};

export const PRODUCT = {
  buyBtn: "product-buy-btn",
  downloadBtn: "product-download-btn",
  stockCounter: "product-stock-counter",
  countdown: "product-countdown",
  title: "product-title",
  price: "product-price",
  shareBtn: "product-share-btn",
};

export const STUDIO = {
  newProductBtn: "studio-new-product-btn",
  titleInput: "studio-title-input",
  descInput: "studio-desc-input",
  priceInput: "studio-price-input",
  stockInput: "studio-stock-input",
  categorySelect: "studio-category-select",
  dropDateInput: "studio-drop-date-input",
  coverUpload: "studio-cover-upload",
  fileUpload: "studio-file-upload",
  createBtn: "studio-create-btn",
  aiTextBtn: "studio-ai-text-btn",
  aiImageBtn: "studio-ai-image-btn",
  aiAudioBtn: "studio-ai-audio-btn",
  aiPrompt: "studio-ai-prompt",
  productsList: "studio-products-list",
  editBtn: (id) => `studio-edit-${id}`,
  deleteBtn: (id) => `studio-delete-${id}`,
  editDialog: "studio-edit-dialog",
  editSaveBtn: "studio-edit-save-btn",
  earningsGross: "studio-earnings-gross",
  earningsNet: "studio-earnings-net",
  earningsSold: "studio-earnings-sold",
  earningsFeePct: "studio-earnings-fee-pct",
  verifiedBadge: "studio-verified-badge",
};

export const CREATOR = {
  page: "creator-profile-page",
  name: "creator-name",
  verifiedBadge: "creator-verified-badge",
  totalDrops: "creator-total-drops",
  totalSold: "creator-total-sold",
};

export const RATING = {
  form: "rating-form",
  starBtn: (n) => `rating-star-${n}`,
  commentInput: "rating-comment-input",
  submitBtn: "rating-submit-btn",
  list: "rating-list",
  avg: "rating-avg",
};

export const PREVIEW = {
  audio: "preview-audio",
  image: "preview-image",
  video: "preview-video",
  ebook: "preview-ebook-locked",
};

export const LIBRARY = {
  emptyState: "library-empty-state",
  itemCard: (id) => `library-item-${id}`,
  downloadBtn: (id) => `library-download-${id}`,
};
